import React from 'react'
import { Button } from 'react-bootstrap'
import useToasts from '../../../hooks/use-toasts'
import useConfirmationDialog from '../../../hooks/use-confirmation-dialog'
import useUserGoalMutations from '../../../hooks/use-user-goal-mutations'

const DeleteButton = ({
    goal,
    ...props
}) => {

    const {
        toastSuccess,
        toastError
    } = useToasts({
        successMessage: 'Goal deleted!',
        errorMessage: 'Unable to delete goal.',
    })

    const {
        deleteGoal,
        isDeleting
    } = useUserGoalMutations({
        userId: goal.userId,
        onSuccess: toastSuccess,
        onError: toastError,
    })

    const { showConfirmation } = useConfirmationDialog({
        title: 'Delete goal?',
        onConfirm: () => deleteGoal(goal.id)
    })

    return (
        <React.Fragment>
            <Button onClick={() => showConfirmation()} {...props} />
        </React.Fragment>
    )
}

export default DeleteButton